module.exports = __webpack_public_path__ + "static/media/5_2.754395a2.png";